<template>
  <div
    class="calendar-card"
    :style="{ background: '#fff', border: '1px solid #d0d0d0', borderRadius: rounded ? '8px' : '0', padding: '24px' }"
  >
    <div class="calendar-card__title" style="font-size: 20px; letter-spacing: -0.6px; margin-bottom: 16px">
      Calendar
    </div>

    <CalendarEvents
      :events="calendarEvents"
      :color-map="colorMap"
      :legend="legend"
      :legend-tooltip="legendTooltip"
      :vertical="vertical"
      @prev-month="handlePrevMonth"
      @next-month="handleNextMonth"
    >
      <template #event-action="{ event }">
        <a
          v-if="
            event.type === 'session_end' ||
            (event.type === 'session_milestone' && event.id?.startsWith('session-start-'))
          "
          href="#"
          class="calendar-card__action"
          style="font-size: 14px; color: #8c1d40; text-decoration: none; white-space: nowrap"
          @click.prevent="handleAddCoursesClick"
        >
          Add courses
        </a>
      </template>
    </CalendarEvents>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue';
import { useCourseDates } from '@/composables/useCourseDates';
import { useSessionMilestones } from '@/composables/useSessionMilestones';
import CalendarEvents from '@/components/ui/CalendarEvents.vue';
import { DataLayerMixin } from '../../mixins/dataLayerMixin';

export default defineComponent({
  name: 'DashboardCalendarCard',
  mixins: [DataLayerMixin],
  components: { CalendarEvents },
  props: {
    vertical: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { allDates } = useCourseDates();
    const { sessionMilestoneEvents } = useSessionMilestones();

    const calendarEvents = computed(() => {
      const merged = [...allDates.value, ...sessionMilestoneEvents.value];
      merged.sort((a, b) => new Date(a.date) - new Date(b.date));
      return merged;
    });

    const colorMap = {
      session_end: '#00A3E0',
      drop_deadline: '#FFC627',
      od_close: '#FFC627',
      convert_credit: '#FFC627',
      session_milestone: '#00A3E0'
    };

    const legend = [
      {
        color: '#FFC627',
        label: 'Important deadline'
      },
      {
        color: '#00A3E0',
        label: 'Session milestone'
      }
    ];

    const legendTooltip = [
      {
        label: 'Important deadlines:',
        description:
          'for course actions include adding courses to your transcript or start and end dates for on-demand course.'
      },
      {
        label: 'Session milestones:',
        description: 'related to the session timeline, including session start and end dates and other key events.'
      }
    ];

    return {
      calendarEvents,
      colorMap,
      legend,
      legendTooltip
    };
  },
  methods: {
    handlePrevMonth() {
      this.asuoDataLayerClick('accelerateDashboard', '34');
    },
    handleNextMonth() {
      this.asuoDataLayerClick('accelerateDashboard', '35');
    },
    handleAddCoursesClick() {
      this.asuoDataLayerClick('accelerateDashboard', '36');
      this.$router.push('/courses-add');
    }
  }
});
</script>

<style scoped>
.calendar-card__title {
  font-family: Arial, sans-serif;
  font-weight: 400;
  color: #000;
}

.calendar-card__action:hover {
  text-decoration: underline !important;
}
</style>
